
export enum ServiceTypes {
  Hotel = "Hotel",
  Car = "Car",
  Plane = "Plane",
  Bus = "Bus",
}
